export default __webpack_public_path__ + "static/media/pratical.634acf39.svg";